<template>
  <div class="violation-form-skeleton" role="status" aria-label="Đang tải biểu mẫu ghi nhận vi phạm">
    <template v-for="(section, sectionIndex) in sections">
      <div :key="`title-${sectionIndex}`" class="skeleton-title">
        <el-skeleton-item variant="circle" />
        <el-skeleton-item variant="text" />
      </div>
      <template v-for="(field, fieldIndex) in section.fields">
        <div :key="`field-${sectionIndex}-${fieldIndex}`" class="skeleton-field">
          <el-skeleton-item variant="text" class="skeleton-label" />
          <div v-if="field === 'options'" class="skeleton-options">
            <el-skeleton-item v-for="option in 2" :key="option" variant="text" />
          </div>
          <div v-else-if="field === 'behaviors'" class="skeleton-behaviors">
            <el-skeleton-item v-for="behavior in 5" :key="behavior" variant="text" />
          </div>
          <el-skeleton-item v-else variant="rect" class="skeleton-input" />
        </div>
      </template>
    </template>
    <div class="skeleton-actions">
      <el-skeleton-item variant="button" />
      <el-skeleton-item variant="button" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViolationFormSkeleton',
  data() {
    return {
      sections: [
        { fields: ['input'] },
        { fields: ['options', 'behaviors', 'input'] },
        { fields: ['input'] },
        { fields: ['input'] }
      ]
    };
  }
};
</script>

<style scoped lang="scss" src="./ViolationFormSkeleton.scss"></style>
